// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"85":"380948cc","145":"723dfe1c","783":"00b587fd"}[chunkId] + ".chunk.js";
};